<template>
    <div class="mobile">
        <qdd-icon class="iconphone_icon" color="#FD3C3C" size=".8rem" ></qdd-icon>
        {{mobile}}
    </div>
</template>
<script>
    import icon from '@/components/iconfont';
    export default {
        components: {
            'qdd-icon':icon
        },
        data(){
            return{
                mobile:''
            }
        },
        mounted() {
            console.log(this.$route.query.mobile)
            this.mobile = this.$route.query.mobile; // 当前积分记录
        }
    }
</script>

<style scoped>
.mobile{
    height: 2rem;
    line-height: 2rem;
    background: #fff;
    font-size: 0.6rem;
    color: #333;
    margin: 0.4rem 0;
    padding: 0 0.5rem;
}
    .iconphone_icon{
        padding-right: 0.4rem;
    }
</style>
